/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { getShouldUnblockUIFeatures } from "selectors/documentSelectors";

export const isReadyToLoadAttachments = stores => stores.lhpStore.attachmentsModel.isReadyToLoadAttachments;

export const attachments = stores => stores.lhpStore.attachmentsModel.attachments;

export const hasAttachments = stores => stores.lhpStore.attachmentsModel.hasAttachments;

export const showAttachmentIcon = stores =>
  stores.lhpStore.attachmentsModel.shouldShowAttachmentIcon &&
  hasAttachments(stores) &&
  getShouldUnblockUIFeatures(stores);
